import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// local
// css
import './EditConfirmDelivery.css';
// view
import Page from 'app/ui/pages/Page';
import EditConfirmBody from './EditConfirmBody';
import EditConfirmFilters from './EditConfirmFilters';
import ConfirmBackModal from './ConfirmBackModal';
// actions
import { back } from 'app/redux/actions/editConfirm/data';
import { openModal } from 'app/redux/actions/editConfirm/backModal';

class EditConfirmDelivery extends Component {
    onClickBack = () => {
        const { returned, delivered } = this.props.editConfirm;
        let found = delivered.find(item => item.isEdit === true || item.isSaved === true);
        if (!found) {
            returned.find(item => item.isEdit === true || item.isSaved === true);
        }
        if (found) {
            this.props.dispatch(openModal());
        } else {
            this.props.dispatch(back());
        }
    };

    render() {
        const { loading } = this.props.editConfirm;
        return (
            <Page id="page-edit-confirm" loading={loading}>
                <div className="page-header">
                    <Icon name="angle left" className="btn-back" onClick={this.onClickBack} />
                    <div className="page-title">EDITAR CONFIRMAÇÕES</div>
                </div>
                <div className="body">
                    <EditConfirmFilters />
                    <EditConfirmBody />
                </div>
                <ConfirmBackModal />
            </Page>
        );
    }
}

EditConfirmDelivery.propTypes = {
    dispatch: PropTypes.func,
    editConfirm: PropTypes.object,
};

const mapStateToProps = state => ({
    editConfirm: state.editConfirm,
});
export default connect(mapStateToProps)(EditConfirmDelivery);
